import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axios";
import { useParams } from "react-router-dom";
import AddSettlement from "../add-settlement";
import AddLoan from "../add-loan";
import Timeline from "./Timeline";
import { changeLoanStatus, getAgent } from "../../redux/actions/agents";
import { useDispatch, useSelector } from "react-redux";

const statusStyles = {
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  red: "bg-red-100 text-red-800",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AgentDetail() {
  const [nameInput, setNameInput] = useState("");
  const [prevStatus, setPrevStatus] = useState(null);
  const [active, setactive] = useState(false);
  const [modal, setModal] = useState(false);
  const [loanModal, setLoanModal] = useState(false);

  const { id } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAgent({ id }));
  }, [dispatch, id]);

  const { agent } = useSelector((state) => state.agents);

  console.log("ASDFGHJKL", agent);
  const initialData = {
    agentId: id,
    reason: "",
    prevStatus: prevStatus,
    newStatus: null,
  };
  const [inputData, setInputData] = useState(initialData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const { reason, newStatus } = inputData;

  useEffect(() => {
    if (agent !== null) {
      setPrevStatus(agent.attributes.loanStatus);
    }
  }, [agent]);

  console.log(prevStatus);

  const changeProfileDetail = (e) => {
    e.preventDefault();
    axiosInstance.put(
      `agents/${id}`,
      {
        data: {
          detail: nameInput,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiaWF0IjoxNjQ5MjczMTc5LCJleHAiOjE2NTE4NjUxNzl9.8sKsjLGuSvE_9Kx2BC5iXYW_zi6QDBQ2Jlm4gTIxroQ",
        },
      }
    );
  };

  const handleLoanStatusChange = (e) => {
    e.preventDefault();

    dispatch(changeLoanStatus({ id, newStatus, reason, prevStatus }));
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  console.log("----------------------------");
  console.log(agent);
  console.log("----------------------------");

  return (
    <>
      {agent !== null && (
        <div className="min-h-full">
          <main className="py-10">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
              <div className="flex items-center space-x-5">
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">
                    {agent.attributes.name}
                  </h1>
                  <p className="text-sm font-medium text-gray-500">
                    Agent since:{" "}
                    <span>{formatDate(agent.attributes.agentSince)}</span>
                  </p>
                </div>
              </div>
              <div className="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
                <button
                  onClick={() => setLoanModal(true)}
                  className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                >
                  Add loan
                </button>
                <button
                  onClick={() => setModal(true)}
                  className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                >
                  Add settlement
                </button>
              </div>
            </div>

            <div className="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
              <div className="space-y-6 lg:col-start-1 lg:col-span-2">
                {/* Description list*/}
                <section aria-labelledby="applicant-information-title">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="flex items-center justify-between px-4 py-5 sm:px-6">
                      <div>
                        <h2
                          id="applicant-information-title"
                          className="text-lg leading-6 font-medium text-gray-900"
                        >
                          Agent Information
                        </h2>
                        <p className="mt-1 max-w-2xl text-sm text-gray-500">
                          Personal details about the agent.
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={(e) => {
                          setactive(!active);
                          changeProfileDetail(e);
                        }}
                        className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                      >
                        Edit Profile
                      </button>
                    </div>

                    <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                      <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Name:
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {!active ? (
                              <span className="flex-grow">
                                {agent.attributes.name}
                              </span>
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  name="name"
                                  id="name"
                                  className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                                  placeholder="Your Display name"
                                  defaultValue={agent.attributes.name}
                                  onChange={(e) => setNameInput(e.target.value)}
                                  onKeyPress={(e) =>
                                    e.key === "Enter" && changeProfileDetail(e)
                                  }
                                />
                              </div>
                            )}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Address
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {!active ? (
                              <span className="flex-grow">
                                {agent.attributes.address}
                              </span>
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  name="address"
                                  id="address"
                                  className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                                  placeholder="Your Display address"
                                  defaultValue={agent.attributes.address}
                                  onChange={(e) => setNameInput(e.target.value)}
                                  onKeyPress={(e) =>
                                    e.key === "Enter" && changeProfileDetail(e)
                                  }
                                />
                              </div>
                            )}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Phone Number
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {!active ? (
                              <span className="flex-grow">
                                {agent.attributes.phoneNo}
                              </span>
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  name="phoneNo"
                                  id="phoneNo"
                                  className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                                  placeholder="Your Display name"
                                  defaultValue={agent.attributes.phoneNo}
                                  onChange={(e) => setNameInput(e.target.value)}
                                  onKeyPress={(e) =>
                                    e.key === "Enter" && changeProfileDetail(e)
                                  }
                                />
                              </div>
                            )}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-500">
                            Loan
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {!active ? (
                              <span className="flex-grow">
                                {parseInt(agent.attributes.loan)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                                Birr
                              </span>
                            ) : (
                              <div>
                                <input
                                  type="text"
                                  name="loan"
                                  id="loan"
                                  className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                                  placeholder="Your Display name"
                                  defaultValue={agent.attributes.loan}
                                  onChange={(e) => setNameInput(e.target.value)}
                                  onKeyPress={(e) =>
                                    e.key === "Enter" && changeProfileDetail(e)
                                  }
                                />
                              </div>
                            )}
                          </dd>
                        </div>
                        <div className="sm:col-span-2">
                          <dt className="text-sm font-medium text-gray-500">
                            Loan Status
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            <span
                              className={classNames(
                                statusStyles[agent.attributes.loanStatus],
                                "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                              )}
                            >
                              {agent.attributes.loanStatus}
                            </span>
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                  <div className="bg-white shadow sm:rounded-lg mt-5">
                    <div className="flex flex-col px-4 py-5 sm:px-6">
                      <div>
                        <span>Change loan status for the agent</span>
                        <select
                          onChange={handleChange}
                          name="newStatus"
                          defaultValue={agent.attributes.loanStatus}
                          className="block pr-8 py-2 my-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
                        >
                          <option value="green">Green</option>
                          <option value="yellow">Yellow</option>
                          <option value="red">Red</option>
                        </select>
                      </div>
                      {newStatus !== null && newStatus !== prevStatus && (
                        <div>
                          <label
                            htmlFor="comment"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Reason for changing status
                          </label>
                          <div className="mt-1">
                            <textarea
                              rows={4}
                              name="reason"
                              id="comment"
                              className="shadow-sm focus:ring-sky-500 focus:border-sky-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              onChange={handleChange}
                            />
                          </div>
                          <button
                            type="button"
                            onClick={handleLoanStatusChange}
                            className="inline-flex items-center justify-center mt-3 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                          >
                            Change Status
                          </button>
                        </div>
                      )}
                      <p></p>
                    </div>
                  </div>
                </section>
              </div>

              <Timeline id={id} agent={agent} />
            </div>
          </main>
        </div>
      )}

      {modal && (
        <AddSettlement
          modal={modal}
          setModal={setModal}
          loan={agent.attributes.loan}
        />
      )}
      {loanModal && (
        <AddLoan
          loanModal={loanModal}
          setLoanModal={setLoanModal}
          loan={agent.attributes.loan}
        />
      )}
    </>
  );
}
